module.exports = __webpack_public_path__ + "static/media/samurai II.8fad5efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/samurai II.jpg
// module id = 83
// module chunks = 0